module.exports = __webpack_public_path__ + "static/media/07en.cf621c56.jpg";